import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BtnShape, BtnText } from '../InvDownload/InvDowload.styled';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { TextField } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';

export const UploadInventoryProductUpdateModal = (props) => {
  const {
    uploadInventoryProductUpdating,
    setUploadInventoryProductUpdating,
    onUploadFile,
    uploadProductsMessage,
    uploadProductsError,
  } = props;
  const { t } = useTranslation();
  const [errorLogo, setErrorLogo] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    title: '',
    subtitle: '',
    severity: 'info',
  });

  useEffect(() => {
    if (uploadProductsMessage) {
      if (
        uploadProductsMessage === t('Inventory.productsCsvUpload.processing')
      ) {
        setSnackbar({
          open: true,
          title: t('Inventory.productsCsvUpload.processing'),
          subtitle: '',
          severity: 'warning',
        });
      } else {
        const processedMessage = processBackendMessage(uploadProductsMessage);
        setSnackbar({
          open: true,
          title: t('Inventory.productsCsvUpload.success'),
          subtitle: processedMessage,
          severity: 'success',
        });
      }
    }
  }, [uploadProductsMessage, t]);

  useEffect(() => {
    if (uploadProductsError) {
      const processedMessage = processBackendMessage(uploadProductsError);
      setSnackbar({
        open: true,
        title: t('Inventory.productsCsvUpload.fail'),
        subtitle: processedMessage,
        severity: 'error',
      });
    }
  }, [uploadProductsError, t]);

  const processBackendMessage = (message) => {
    try {
      if (typeof message === 'string' && message.startsWith('{')) {
        const parsed = JSON.parse(message);

        if (
          typeof parsed.message === 'string' &&
          parsed.message.startsWith('{')
        ) {
          try {
            const innerParsed = JSON.parse(parsed.message);
            return formatMessageWithErrors(innerParsed);
          } catch (innerError) {
            return formatMessageWithErrors(parsed);
          }
        }

        return formatMessageWithErrors(parsed);
      }
      return message;
    } catch (error) {
      return message;
    }
  };

  const formatMessageWithErrors = (parsedData) => {
    let formattedMessage = parsedData.message || '';

    if (parsedData.errors && Array.isArray(parsedData.errors)) {
      formattedMessage += `\n\n${t(
        'Inventory.productUpdateUpload.errorDetails',
      )}`;

      parsedData.errors.forEach((error, index) => {
        if (error.product_id) {
          formattedMessage += `\n• ${t(
            'Inventory.productUpdateUpload.errorProductId',
          )} ${error.product_id}:`;

          if (error.errors) {
            if (
              typeof error.errors === 'object' &&
              !Array.isArray(error.errors)
            ) {
              Object.entries(error.errors).forEach(([field, fieldErrors]) => {
                if (Array.isArray(fieldErrors)) {
                  fieldErrors.forEach((fieldError) => {
                    formattedMessage += ` ${field}: ${fieldError}`;
                  });
                } else {
                  formattedMessage += ` ${field}: ${fieldErrors}`;
                }
              });
            } else if (typeof error.errors === 'string') {
              formattedMessage += ` ${error.errors}`;
            } else if (Array.isArray(error.errors)) {
              error.errors.forEach((fieldError) => {
                formattedMessage += ` ${fieldError}`;
              });
            }
          }
        }
      });
    }

    return formattedMessage;
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleFileChange = () => {
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput.files[0]) {
      if (fileInput.files[0].type === 'text/csv') {
        if (fileInput.files[0].size <= 5 * 1024 * 1024) {
          setErrorLogo('');
        } else {
          setErrorLogo(t('Inventory.productUpdateUpload.helperText.fileSize'));
          document.querySelector('input[type="file"]').value = null;
        }
      } else {
        setErrorLogo(t('Inventory.productUpdateUpload.helperText.fileType'));
        document.querySelector('input[type="file"]').value = null;
      }
    } else {
      document.querySelector('input[type="file"]').value = null;
    }
  };

  const onSubmitFile = async (event) => {
    event.preventDefault();
    setUploadInventoryProductUpdating(true);
    const fileInput = document.querySelector('input[type="file"]');
    if (!fileInput.files[0]) {
      setErrorLogo(t('Inventory.productUpdateUpload.helperText.noFile'));
      setUploadInventoryProductUpdating(false);
      return;
    }
    if (fileInput.files[0].type !== 'text/csv') {
      setErrorLogo(t('Inventory.productUpdateUpload.helperText.fileType'));
      setUploadInventoryProductUpdating(false);
      return;
    }
    try {
      onUploadFile(fileInput.files[0]);
    } catch (error) {
      setUploadInventoryProductUpdating(false);
    }
  };

  return (
    <>
      <form onSubmit={onSubmitFile}>
        <DialogTitle>
          {t('Inventory.productUpdateUpload.dialogTitle')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <b>{t('Inventory.productUpdateUpload.dialogText')}</b>
            <br />
            <b>{t('Inventory.productUpdateUpload.dialogTextSubTitle')}</b>
          </DialogContentText>
          <br />
          <TextField
            type="file"
            accept=".csv"
            placeholder="Seleccionar archivo CSV"
            className="uploadCsvFileWrap"
            name="productUpdateFile"
            variant="outlined"
            onChange={handleFileChange}
            helperText={errorLogo}
            required
            fullWidth
          />
          <br />
          <br />
          <DialogActions>
            <Box display="flex" alignItems="center" position="relative">
              <Box ml={2}>
                <Snackbar
                  open={snackbar.open}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  style={{ position: 'static', marginRight: '15px' }}>
                  <Alert
                    severity={snackbar.severity}
                    style={{
                      padding: '8px 16px',
                      minWidth: '370px',
                      maxWidth: '500px',
                    }}>
                    <div>
                      <div
                        style={{
                          fontWeight: 'bold',
                          marginBottom: snackbar.subtitle ? '8px' : '0',
                        }}>
                        {snackbar.title}
                      </div>
                      {snackbar.subtitle && (
                        <div
                          style={{
                            fontSize: '0.9em',
                            opacity: 0.9,
                            whiteSpace: 'pre-line',
                            lineHeight: '1.4',
                            maxHeight: '150px',
                            overflowY: 'auto',
                          }}>
                          {snackbar.subtitle}
                        </div>
                      )}
                    </div>
                  </Alert>
                </Snackbar>
              </Box>
              <BtnShape
                type="submit"
                disabled={uploadInventoryProductUpdating}
                style={{ minWidth: '155px' }}>
                <CloudUploadIcon />
                <BtnText>
                  {t('Inventory.productUpdateUpload.buttonUploadFile')}
                </BtnText>
              </BtnShape>
            </Box>
          </DialogActions>
        </DialogContent>
        <br />
      </form>
    </>
  );
};

UploadInventoryProductUpdateModal.propTypes = {
  handleClose: PropTypes.func,
  uploadInventoryProductUpdating: PropTypes.bool,
  setUploadInventoryProductUpdating: PropTypes.func,
  onUploadFile: PropTypes.func,
  uploadProductsMessage: PropTypes.string,
  uploadProductsError: PropTypes.string,
};
